module.exports = __webpack_public_path__ + "img/neck-ecto-mesomorph-female.d2241a0e.svg";